import { Button, LoadingButton, Section } from '@cmg/design-system';
import React, { useMemo } from 'react';

import type { IndicationStatus as TIndicationStatus } from '../../../../../../../../graphql';
import { useIndicationSectionActions } from '../../hooks/useIndicationSectionActions';
import IndicationStatus from '../indication-status/IndicationStatus';

export type IndicationSectionWithEditButtonsProps = {
  indicationStatus: TIndicationStatus;
  isPassButtonVisible: boolean;
  isPassButtonDisabled: boolean;
  isSubmitting: boolean;
  handlePass: () => void;
  handleDiscard: () => void;
  handleSubmit: () => void;
};

export const IndicationSectionWithEditButtons: React.FC<
  React.PropsWithChildren<IndicationSectionWithEditButtonsProps>
> = ({
  children,
  indicationStatus,
  isPassButtonVisible,
  isPassButtonDisabled,
  handlePass,
  handleDiscard,
  handleSubmit,
  isSubmitting,
}) => {
  const indicationSectionActionsParams = useMemo(
    () => ({
      actions: [
        ...(isPassButtonVisible
          ? [
              <Button
                key="pass"
                variant="outlined"
                disabled={isPassButtonDisabled}
                onClick={handlePass}
              >
                Pass
              </Button>,
            ]
          : []),
        <Button key="discard" variant="outlined" disabled={isSubmitting} onClick={handleDiscard}>
          Discard Changes
        </Button>,
        <LoadingButton
          key="submit"
          variant="contained"
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          Save
        </LoadingButton>,
      ],
      smallScreenActions: [
        <LoadingButton
          key="submit"
          variant="contained"
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          Save
        </LoadingButton>,
      ],
      smallScreenContextMenuActions: [
        ...(isPassButtonVisible
          ? [
              {
                key: 'pass',
                label: 'Pass',
                onClick: handlePass,
              },
            ]
          : []),
        {
          key: 'discard',
          label: 'Discard Changes',
          onClick: handleDiscard,
        },
      ],
    }),
    [
      isPassButtonVisible,
      isPassButtonDisabled,
      handlePass,
      handleDiscard,
      handleSubmit,
      isSubmitting,
    ]
  );
  const actions = useIndicationSectionActions(indicationSectionActionsParams);
  return (
    <Section
      data-testid="edit-indication-view"
      title="Indication"
      titleItems={<IndicationStatus status={indicationStatus} />}
      actions={actions}
    >
      {children}
    </Section>
  );
};
